// extracted by mini-css-extract-plugin
export default {"deleteButton":"DeleteButton_deleteButton__KcMph"};